import { request } from '../utils/api'

export function getSystemStatus () {
  return request({
    method: 'GET',
    url: 'system-info/maintenance-mode'
  }).then(response => response)
}